import React from "react";
import HistorySection from "./about/HistorySection";
import CultureSection from "./about/CultureSection";
import LocationSection from "./about/LocationSection";
import ValuesSection from "./about/ValuesSection";

const About = () => {
  return (
    <main>
      <HistorySection />
      <CultureSection />
      <LocationSection />
      <ValuesSection />
    </main>
  );
};

export default About;
